var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "d-flex justify-content-center" }, [
    _c(
      "ul",
      { staticClass: "pagination m-0" },
      _vm._l(_vm.pagerItems, function (page, index) {
        return _c(
          "li",
          { key: index, staticClass: "page-item", class: page.class },
          [
            page.url
              ? _c(
                  "a",
                  {
                    staticClass: "page-link",
                    class: { disabled: page.class !== "active" },
                    attrs: { href: page.url },
                  },
                  [_vm._v(_vm._s(page.label))]
                )
              : _c(
                  "a",
                  {
                    staticClass: "page-link",
                    class: { disabled: page.class !== "active" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.$emit("page-changed", page.page)
                      },
                    },
                  },
                  [_vm._v(_vm._s(page.label))]
                ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }